export default __webpack_public_path__ + "static/media/icon_tooltip_24x24.6a24734b.svg";